import React, { useState, createContext, useContext, ReactNode } from "react";
import { ProSidebarProvider } from "react-pro-sidebar";
import MyProSidebar from "./MyProSidebar";

type SidebarContextValue = {
  sidebarRTL: boolean;
  setSidebarRTL: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarBackgroundColor?: string;
  setSidebarBackgroundColor: React.Dispatch<React.SetStateAction<string | undefined>>;
  sidebarImage?: string;
  setSidebarImage: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const SidebarContext = createContext<SidebarContextValue | undefined>(undefined);

export const MyProSidebarProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarRTL, setSidebarRTL] = useState(false);
  const [sidebarBackgroundColor, setSidebarBackgroundColor] =
    useState<string | undefined>(undefined);
  const [sidebarImage, setSidebarImage] = useState<string | undefined>(undefined);
  return (
    <ProSidebarProvider>
      <SidebarContext.Provider
        value={{
          sidebarBackgroundColor,
          setSidebarBackgroundColor,

          sidebarImage,
          setSidebarImage,

          sidebarRTL,
          setSidebarRTL,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: sidebarRTL ? "row-reverse" : "row",
          }}
        >
          <MyProSidebar />
          {children}
        </div>
      </SidebarContext.Provider>
    </ProSidebarProvider>
  );
};

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebarContext must be used within a MyProSidebarProvider");
  }
  return context;
};
